import * as Icons from "lucide-react";
import { LucideProps } from "lucide-react";

interface DynamicIconProps extends LucideProps {
    name: string; // Veritabanından gelen ikon adı (Örn: 'ShieldCheck')
}

export const DynamicIcon = ({ name, ...props }: DynamicIconProps) => {
    // 1. Gelen metin (string) ile Lucide kütüphanesindeki ikonları eşleştir
    // 2. Eğer acente yanlış bir ikon adı girdiyse veya boş bıraktıysa, varsayılan olarak 'Box' ikonunu göster (Uygulamanın patlamasını önler)
    const IconComponent = (Icons as any)[name] || Icons.Box;

    return <IconComponent {...props} />;
};